/***
 * mobile nav js
 */
(function () {
  var delay_show_mm = 300,
  delay_hide_mm = 300
  var mobile_nav_block = $('#panel-menu__modify'),
    clone_dom = null,
    current_id = 0

  if ($('.mainmenumob-js').length) {
    //mobile_nav_block.find('ul').eq(0).append(getExternalContainer())
    $('.mainmenumob-js').on('click', function () {
      init_mobile_nav()
    })
  }

  function init_mobile_nav() {
    mobile_nav_block.initMK().open_moblie_menu()
  }

  function getButtonClose(text) {
    text = text || 'Close'
    return (
      '<li class="mm-close-parent"><a class="mm-close mobile-menu-close-btn">' +
      text +
      '</a></li>'
    )
  }

  function getFullscreenBg() {
    return '<div class="mobile-fullscreen-bg"></div>'
  }

  function getExternalContainer() {
    return '<li id="entrypoint-objects" class="entrypoint-objects__wrapper"></li>'
  }

  function trachSensorABtest() {
    abtest.fastFetchABTest({
      param_name:"HideAccess",
      default_value:false,
      value_type:"Boolean",
      callback: function(result){
          if(result) {
              // 关闭XCC入口
              $('.panel-menu__modify.mobile-main-menu.mmitemopen ul li.li-level-1 a').each(function() {
                if($(this).text() == 'XCC - New Member Benefits') {
                  $(this).parent().parent().remove();
                }
              })
          }
      }
    });
  }

  $('body').append(getFullscreenBg())

  $('.mobile-fullscreen-bg').on('click', function () {
    mobile_nav_block.close_moblie_menu()
  })

  $(document).on('click', '.mobile-menu-close-btn', function () {
    mobile_nav_block.close_moblie_menu()
  })

  $.fn.extend({
    open_moblie_menu: function () {
      var that = this
      this.show()
      setTimeout(function () {
        $('body').addClass('mm-open')
        $(that).addClass('mmitemopen')
        $('.mobile-fullscreen-bg').fadeIn(delay_show_mm)
        trachSensorABtest()
      }, 0)
    },
    close_moblie_menu: function () {
      var that = $(this)
      that.addClass('mmhide')
      $('.mobile-fullscreen-bg').fadeOut(delay_hide_mm)
      setTimeout(function () {
        mobile_menu_destroy.call(that)
      }, delay_hide_mm)
    },

    initMK: function () {
      var _this = $(this)
      clone_dom = $(this).children().clone()

      $(this)
        .find('.a-level')
        .each(function () {
          hide_arrow.call($(this))
          $(this)
            .siblings('.right-content__arrow')
            .on('click', function (e) {
              // e.preventDefault()
              hide_other_menu_block.call($(this))
              $(this)
                .parent('.item-wrapper')
                .siblings('ul')
                .toggleClass('mobile-menu__hide')
                .toggleClass('open-status')
              $(this).toggleClass('arrow-up')
              if (!$(this).hasClass('arrow-up')) {
                close_children_block.call($(this))
              }
            })
        })

      $(this)
        .find('ul')
        .each(function (index) {
          if ($(this).parents('.entrypoint-objects__wrapper').length) return
          if (index != 0) {
            $(this).addClass('mobile-menu__hide').removeClass('open-status')
          } else {
            $(this)
              .find('li')
              .each(function (i) {
                $(this).attr('li_id', i)
              })
            if (!$(this).find('li').first().hasClass('mm-close-parent')) {
              $(this).prepend(getButtonClose())
            }
          }
        })


      $(this)
      .find('ul.ul-level-2.mobile-menu__hide')
      .each(function (level2Index) {
        if (level2Index === 0) {
          $(this).removeClass('mobile-menu__hide').addClass('open-status')
          $(this).find('ul.ul-level-3.mobile-menu__hide').each(function (level3Index) {
            if (level3Index === 0) {
              $(this).removeClass('mobile-menu__hide').addClass('open-status')
            }
          })
        }
      })

      $('.li-level-1 .arrow-level-1.right-content__arrow').on('click', function () {
        current_id = $(this).parents('.li-level-1').attr('li_id')
      })

      function hide_arrow() {
        if ($(this).parent('.item-wrapper').siblings('ul').length) {
          $(this).siblings('span').addClass('right-content__arrow')
        }
      }

      function hide_other_menu_block() {
        if (
          !$(this).hasClass('arrow-level-1') ||
          !_this.find('.open-status').length
        )
          return
        if (current_id == $(this).parents('.li-level-1').attr('li_id')) return
        
        _this.find('.arrow-up').each(function () {
          $(this).removeClass('arrow-up')
        })
        _this.find('.open-status').each(function () {
          $(this).addClass('mobile-menu__hide').removeClass('open-status')
        })
      }

      function close_children_block() {
        $(this)
          .parent('.item-wrapper')
          .parent('li')
          .find('ul')
          .each(function (index) {
            if (index != 0) {
              $(this).addClass('mobile-menu__hide').removeClass('open-status')
            }
          })
        $(this)
          .parent('.item-wrapper')
          .parent('li')
          .find('.right-content__arrow')
          .each(function (index) {
            $(this).removeClass('arrow-up')
          })
      }
      return _this
    },
  })

  function mobile_menu_destroy() {
    $('body').removeClass('mm-open')
    $(this).empty().append(clone_dom)
    $(this).toggleClass('mmhide mmitemopen', false).hide()
  }
})()
